import { createSlice } from '@reduxjs/toolkit';
import { IHealthPlanType } from '../Infrastructure/Interfaces';
  
  const ItemInitialState: IHealthPlanType = {
    healthPlanTypeId: 0,
    healthPlanType: '',
    createdBy: '',
    createdOn: '',
    modifiedBy: '',
    modifiedOn: '',
  }
  
  const HealthPlanTypeItemSlice = createSlice({
    name:'HealthPlanTypeItem',
    initialState:{value:ItemInitialState},
    reducers:{
        setHealthPlanTypeItem:(state,action)=>{
            state.value = action.payload
        }
    }
  })
    
  export const {setHealthPlanTypeItem} = HealthPlanTypeItemSlice.actions;
  
  export const HealthPlanTypeItemReducer = HealthPlanTypeItemSlice.reducer;